import React, { useEffect, useMemo, useState } from 'react';
import './FabricInquiriesDetails.css';
import { useMediaQuery } from '@mantine/hooks';
import Navigation from '../sidebar/Navigation';
import { useNavigate } from 'react-router-dom';
import { createB2BAPI } from '../../../api/Interceptor';
import { BASE_URL } from '../../../api/EndPoints';
import notify from '../../../utils/Notification';
import { IconArrowAutofitRight, IconArrowLeft, IconArrowRampRight, IconArrowRight } from '@tabler/icons-react';
import { Button } from '@mantine/core';

import { useLoader } from '../../../Context/LoaderContext';

const VendorFabricInquiriesDetails = () => {

    const isMobile = useMediaQuery('(max-width: 767px)');
    const isTablet = useMediaQuery('(min-width: 768px) and (max-width: 991px)');

    const [inquiries, setInquiries] = useState([]);
    const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 5 });
    const [totalPages, setTotalPages] = useState(0);
    const [totalElements, setTotalElements] = useState(0);

    const navigate = useNavigate();
    const { showLoader, hideLoader } = useLoader();
    const B2B_API = useMemo(() => createB2BAPI(navigate), [navigate]);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        fetchAllProducts();
    }, [pagination.pageIndex]);

    const fetchAllProducts = async () => {

        setLoading(true);
        showLoader();

        try {

            const response = await B2B_API.get(
                `inquiryProduct/search?page=${pagination.pageIndex}&size=${pagination.pageSize}&searchTerm=`
            );

            const data = await response.json();

            const productsData = data?.response?.content || [];

            setInquiries(productsData);
            setTotalPages(data?.response?.totalPages || 0);
            setTotalElements(data?.response?.totalElements || 0);

        } catch (error) {

            notify({
                id: 'fetch_Vendor_inquiries',
                error: true,
                success: false,
                title: error?.message || 'Error fetching Vendor Inquiries',
            });

        } finally {
            setLoading(false);
            hideLoader();
        }
    };

    const formatDate = (timestamp) => {
        const date = new Date(timestamp);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    const handleRowClick = (id) => {
        navigate(`/fabric-MyInquiry-Vendor?id=${id}`);
    };

    const nextPage = () => {
        if (pagination.pageIndex < totalPages - 1) {
            setPagination((prev) => ({
                ...prev,
                pageIndex: prev.pageIndex + 1
            }));
        }
    };

    const prevPage = () => {
        if (pagination.pageIndex > 0) {
            setPagination((prev) => ({
                ...prev,
                pageIndex: prev.pageIndex - 1
            }));
        }
    };

    return (
        <div className="view-my-page router-view-container">

            {(!isMobile && !isTablet) && <Navigation />}

            <div className="view-fabric-inquiries-v2 route-view">
                <div style={{ display: "flex", flexDirection: "row", gap: '20px' }}>
                    <div className="section-header" style={{ gap: "0px" }}>
                        <div className="page-title">New Development</div>
                        <div
                            className="total-number"
                            style={{
                                backgroundColor: "#8bc53f",
                                borderRadius: "50%",
                                width: "20px",
                                height: "20px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "white",
                                fontSize: "14px",
                                fontWeight: "600"
                            }}
                        >
                            {totalElements}
                        </div>
                    </div>
                    <div>
                        <button
                            className="btn btn-primary"
                            onClick={() => navigate("/vendorFabricInquiry/new")}
                        >
                            <i className="far fa-plus m-r-4"></i>
                            CREATE NEW
                        </button>
                    </div>
                </div>

                <section className="resolved m-t-32">
                    <div
                        className="list-fabric-inquiries-v2"
                        style={{
                            padding: "0px",
                            border: "1px solid #e5e5e5",
                            borderRadius: "8px",
                            overflow: "hidden",
                            background: "#ffffff"
                        }}
                    >

                        {!isMobile && (
                            <div
                                className="thead"
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr",
                                    padding: "12px 15px",
                                    background: "#f8f9fa",
                                    borderBottom: "1px solid #e5e5e5",
                                    fontWeight: "900",
                                    fontSize: "13px",
                                    alignItems: "center"
                                }}
                            >
                                <div>Development Details</div>
                                <div>UOM</div>
                                <div>Price</div>
                                <div>Width</div>
                                <div>Weight</div>
                            </div>
                        )}

                        <div
                            className="tbody"
                            style={{
                                padding: "0px"
                            }}
                        >
                            {loading ? (
                                <div
                                    style={{
                                        padding: "40px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}
                                >
                                    <div className="loader"></div>
                                </div>
                            ) : inquiries.length > 0 ? (
                                inquiries.map((inquiry, index) => {
                                    return (
                                        <div
                                            key={inquiry.id}
                                            style={{
                                                display: isMobile ? "flex" : "grid",
                                                flexDirection: isMobile ? "column" : "row",
                                                gridTemplateColumns: isMobile ? undefined : "2fr 1fr 1fr 1fr 1fr",
                                                alignItems: isMobile ? "flex-start" : "center",
                                                padding: "16px 15px",
                                                gap: "10px",
                                                borderBottom: "1px solid #f1f1f1",
                                                cursor: "pointer",
                                                background: index % 2 === 0 ? "#ffffff" : "#fafafa",
                                                transition: "all 0.2s"
                                            }}
                                            onMouseEnter={(e) =>
                                                (e.currentTarget.style.background = "#f3f6f9")
                                            }
                                            onMouseLeave={(e) =>
                                            (e.currentTarget.style.background =
                                                index % 2 === 0 ? "#ffffff" : "#fafafa")
                                            }
                                            onClick={() => handleRowClick(inquiry?.id)}
                                        >

                                            <div
                                                className="inquiry-detail"
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "10px",
                                                    width: '100%'
                                                }}
                                            >
                                                <div className="left">
                                                    <div
                                                        className="img-container"
                                                        style={{
                                                            border: "1px solid #e5e5e5",
                                                            borderRadius: "6px",
                                                            width: isMobile ? "60px" : "45px",
                                                            height: isMobile ? "60px" : "45px",
                                                            overflow: "hidden",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            background: "#fff"
                                                        }}
                                                    >
                                                        <img
                                                            src={
                                                                inquiry?.vendorImages?.length > 0
                                                                    ? `${BASE_URL.replace("/api", "")}${inquiry.vendorImages[0]
                                                                    }?time=${Date.now()}`
                                                                    : "/no-image.png"
                                                            }
                                                            alt="vendor"
                                                            style={{
                                                                width: "100%",
                                                                height: "100%",
                                                                objectFit: "cover"
                                                            }}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="rig" style={{ flex: 1 }}>
                                                    <div
                                                        className="tit"
                                                        style={{
                                                            fontSize: isMobile ? "16px" : "14px",
                                                            fontWeight: "600",
                                                            color: "#333",
                                                            marginBottom: isMobile ? "4px" : "0"
                                                        }}
                                                    >
                                                        {inquiry.articleName}
                                                    </div>
                                                    {isMobile && (
                                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', fontSize: '13px', color: '#555', marginTop: '8px' }}>
                                                            <div><span style={{color: '#888'}}>UOM:</span> {inquiry?.otherInformation?.unitOfMeasures?.isKg ? "KG" : inquiry?.otherInformation?.unitOfMeasures?.isMeter ? "METER" : inquiry?.otherInformation?.unitOfMeasures?.isYard ? "YARD" : "-"}</div>
                                                            <div><span style={{color: '#888'}}>Price:</span> ₹{inquiry?.vendorProductInfo?.costPrice || "-"}</div>
                                                            <div><span style={{color: '#888'}}>Width:</span> {inquiry?.metrics?.width || "-"}</div>
                                                            <div><span style={{color: '#888'}}>Weight:</span> {inquiry?.metrics?.weight || "-"}</div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {!isMobile && (
                                                <>
                                                    <div style={{ fontSize: "13px", color: "#555", fontWeight: "500" }}>
                                                        {inquiry?.otherInformation?.unitOfMeasures?.isKg ? "KG" : inquiry?.otherInformation?.unitOfMeasures?.isMeter ? "METER" : inquiry?.otherInformation?.unitOfMeasures?.isYard ? "YARD" : ""}
                                                    </div>
                                                    <div style={{ fontSize: "13px", color: "#555", fontWeight: "500" }}>
                                                        ₹{inquiry?.vendorProductInfo?.costPrice}
                                                    </div>
                                                    <div style={{ fontSize: "13px", color: "#555", fontWeight: "500" }}>
                                                        {inquiry?.metrics?.width}
                                                    </div>
                                                    <div style={{ fontSize: "13px", color: "#555", fontWeight: "500" }}>
                                                        {inquiry?.metrics?.weight}
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    );
                                })
                            ) : (
                                <div
                                    className="empty"
                                    style={{
                                        padding: "40px",
                                        textAlign: "center"
                                    }}
                                >
                                    <div
                                        className="bold"
                                        style={{
                                            fontSize: "16px",
                                            fontWeight: "600",
                                            marginBottom: "10px"
                                        }}
                                    >
                                        No Development yet
                                    </div>

                                    <div
                                        className="text"
                                        style={{
                                            fontSize: "14px",
                                            color: "#777",
                                            marginBottom: "20px"
                                        }}
                                    >
                                        Make a New Development to get help finding
                                        <br />
                                        fabrics that will best fit your sourcing needs.
                                    </div>

                                    <button
                                        className="btn btn-primary"
                                        onClick={() => navigate("/vendorFabricInquiry/new")}
                                        style={{
                                            background: "#8BC53F",
                                            border: "none",
                                            padding: "10px 16px",
                                            borderRadius: "6px",
                                            fontWeight: "500",
                                            cursor: "pointer"
                                        }}
                                    >
                                        NEW DEVELOPMENT
                                    </button>
                                </div>
                            )}
                        </div>


                        {totalPages > 1 && (
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                    gap: "12px",
                                    marginTop: "10px",
                                    padding: "10px"
                                }}
                            >
                                <Button
                                    onClick={prevPage}
                                    disabled={pagination.pageIndex === 0}
                                    leftSection={<IconArrowLeft stroke={2} />}
                                    style={{
                                        padding: "6px 14px",
                                        borderRadius: "6px",
                                        border: "none",
                                        backgroundColor:
                                            pagination.pageIndex === 0 ? "#e6e6e6" : "#8BC53F",
                                        color: pagination.pageIndex === 0 ? "#999" : "black",
                                        cursor: pagination.pageIndex === 0 ? "not-allowed" : "pointer",
                                        fontSize: "13px",
                                        fontWeight: "500"
                                    }}
                                >
                                    Prev
                                </Button>

                                <span
                                    style={{
                                        fontSize: "13px",
                                        fontWeight: "500",
                                        color: "#333"
                                    }}
                                >
                                    {pagination.pageIndex + 1} of {totalPages}
                                </span>

                                <Button
                                    onClick={nextPage}
                                    rightSection={<IconArrowRight stroke={2} />}
                                    disabled={pagination.pageIndex === totalPages - 1}
                                    style={{
                                        padding: "6px 14px",
                                        borderRadius: "6px",
                                        border: "none",
                                        backgroundColor:
                                            pagination.pageIndex === totalPages - 1
                                                ? "#e6e6e6"
                                                : "#8BC53F",
                                        color:
                                            pagination.pageIndex === totalPages - 1
                                                ? "#999"
                                                : "black",
                                        cursor:
                                            pagination.pageIndex === totalPages - 1
                                                ? "not-allowed"
                                                : "pointer",
                                        fontSize: "13px",
                                        fontWeight: "500"
                                    }}
                                >
                                    Next
                                </Button>
                            </div>
                        )}
                    </div>
                </section>

            </div>

        </div>
    );
};

export default VendorFabricInquiriesDetails;